/* eslint-disable @typescript-eslint/no-shadow */
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AgendaAgentePublicoService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }
  listar(data) {
    return new Promise(async (resolve) => {
      this.http
        .get(
          'https://project-5082f113-c983-477a-973.uw.r.appspot.com/AgendaAgentePublico/Listar?data=' + data
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // navigator.app.exitApp();
          }
        );
    });
  }
  listarLocais() {
    return new Promise(async (resolve) => {
      this.http
        .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/AgendaAgentePublico/ListarLocais')
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // navigator.app.exitApp();
          }
        );
    });
  }
  listarPorAutoridade(id) {
    return new Promise(async (resolve) => {
      this.http
        .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/AgendaAgentePublico/ListarPorAutoridade?id='+id)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // navigator.app.exitApp();
          }
        );
    });
  }
}
